import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { v4 as uuid } from 'uuid';

import { ErrorTranslateService } from '../error-translate-service';
import { BaseFormErrorTranslateService } from '../form-common-error/base-form-error-translate.service';
import { SdIconComponent } from '../../icons/icon/icon.component';
import { SdHtmlComponent } from '../../html/html.component';

@Component({
  selector: 'sd-form-libelle',
  templateUrl: './form-libelle.component.html',
  standalone: true,
  imports: [
    NgClass,
    SdIconComponent,
    SdHtmlComponent
  ],
  providers: [
    { provide: BaseFormErrorTranslateService, useClass: ErrorTranslateService }
  ]
})
export class SdFormLibelleComponent implements OnInit {
  uuidLabel: string = uuid();

  @Input()
  labelTitle: string;

  @HostBinding('class.is-visually-hidden')
  @Input()
  labelHidden: boolean;

  @Input()
  labelIcon: string;

  @Input()
  idField = '';

  @Input()
  idLabel = '';

  @Input()
  required: boolean;

  ngOnInit() {
    if (!this.idLabel) {
      this.idLabel = this.uuidLabel;
    }
  }
}
